import React, { useState, useEffect } from 'react';
import { Clock, CheckCircle2, XCircle } from 'lucide-react';
import api from '../../axios';
import ApprovalProjectsDataTable from './ApprovalProjectsDataTable';
// import AuthCheck from '../components/authcheck';


const ApproverDashboard = () => {
  const [activeTab, setActiveTab] = useState("pending");
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loggedInUser = JSON.parse(localStorage.getItem("user"));
    if(loggedInUser?.role_id == 0){
      window.location.href = "/home"; // Redirect if not logged in
      return;
    }
    if (!loggedInUser?.id) {
      window.location.href = "/login"; // Redirect if not logged in
      return;
    }

    const fetchProjects = async () => {
      try {
        const response = await api.get(`/approver-projects/${loggedInUser.id}`);
        if (Array.isArray(response.data.projects)) {
          setProjects(response.data.projects);
        } else {
          console.error("Invalid API response: expected an array");
          setProjects([]); // Fallback to empty array
        }
      } catch (error) {
        console.error("Error fetching projects:", error);
        setError("Failed to load projects");
      } finally {
        setLoading(false);
      }
    };

    fetchProjects();
  }, []);

  // Ensure projects is always an array
  const validProjects = Array.isArray(projects) ? projects : [];

  // Stats Calculation
  const stats = {
    pending: validProjects.filter(p => p.status === "pending").length,
    approved: validProjects.filter(p => p.status === "approved").length,
    rejected: validProjects.filter(p => p.status === "rejected").length,
  };

  return (
    <div className="min-h-screen bg-gray-50 p-4 md:p-6 mt-20">
      {/* Header */}
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900">Approver Dashboard</h1>
        <p className="text-gray-600">Manage and review building design submissions</p>
      </div>

      <ApprovalProjectsDataTable />

      

    </div>
  );
};

/** Stat Card Component */
const StatCard = ({ title, count, icon }) => (
  <div className="bg-white p-4 rounded-lg shadow-sm">
    <div className="flex items-center justify-between">
      <div>
        <p className="text-gray-500">{title}</p>
        <p className="text-2xl font-bold text-gray-900">{count}</p>
      </div>
      {icon}
    </div>
  </div>
);

export default ApproverDashboard;
